import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPaperPlane, FaChevronDown, FaChevronUp, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <footer className="footer-container">
      <Container>
        {/* Mobile: Compact About Section */}
        <div className="footer-mobile-about d-md-none">
          <h4 className="footer-brand">UniTrade</h4>
          <p className="footer-tagline">Your Campus Marketplace</p>
          <div className="footer-contact-compact">
            <div className="mb-2">
              <strong>Technical Team:</strong>
              <div><a href="tel:+233530913920" className="contact-link"><FaPhone className="me-1" />053 091 3920</a></div>
            </div>
            <div>
              <strong>Customer Service:</strong>
              <div><a href="tel:+233542557989" className="contact-link"><FaPhone className="me-1" />054 255 7989</a></div>
            </div>
          </div>
          <div className="social-icons-mobile">
            <a href="https://facebook.com/unitrade" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
            <a href="https://twitter.com/@unitrade_nexus" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://instagram.com/unitrade.nexus/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://linkedin.com/in/unitrade-nexus-coders-44527a373/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
          </div>
        </div>

        {/* Mobile: Accordion Sections */}
        <div className="footer-accordion d-md-none">
          <div className="footer-accordion-item">
            <button 
              className="footer-accordion-header"
              onClick={() => toggleSection('links')}
            >
              <span>Quick Links</span>
              {expandedSection === 'links' ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {expandedSection === 'links' && (
              <div className="footer-accordion-content">
                <Link to="/about">About Us</Link>
                <Link to="/products">Products</Link>
                <Link to="/faq">FAQ</Link>
                <Link to="/contact">Contact</Link>
              </div>
            )}
          </div>

          <div className="footer-accordion-item">
            <button 
              className="footer-accordion-header"
              onClick={() => toggleSection('legal')}
            >
              <span>Legal</span>
              {expandedSection === 'legal' ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {expandedSection === 'legal' && (
              <div className="footer-accordion-content">
                <Link to="/privacy">Privacy Policy</Link>
                <Link to="/terms">Terms of Service</Link>
                <Link to="/disclaimer">Disclaimer</Link>
                <Link to="/cookies">Cookie Policy</Link>
              </div>
            )}
          </div>
        </div>

        {/* Desktop: Original Layout */}
        <Row className="d-none d-md-flex">
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <h5>About UniTrade</h5>
            <p>
              The ultimate campus marketplace designed for students. Buy, sell, and trade textbooks, electronics, and more within your university community.
            </p>
            <div className="mb-3">
              <p className="mb-2"><strong>Technical Team:</strong></p>
              <p className="mb-1"><a href="tel:+233530913920">053 091 3920</a> | <a href="tel:+233545048441">054 504 8441</a> | <a href="tel:+233559489824">055 948 9824</a></p>
            </div>
            <div className="mb-3">
              <p className="mb-2"><strong>Customer Service:</strong></p>
              <p className="mb-1"><a href="tel:+233542557989">054 255 7989</a> | <a href="tel:+233535542438">053 554 2438</a> | <a href="tel:+233558059440">055 805 9440</a></p>
            </div>
            <div className="social-icons mt-4">
              <a href="https://facebook.com/unitrade" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="https://twitter.com/@unitrade_nexus" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://instagram.com/unitrade.nexus/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://linkedin.com/in/unitrade-nexus-coders-44527a373/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            </div>
          </Col>

          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/about">About Us</Link></li>
              <li className="mb-2"><Link to="/products">Products</Link></li>
              <li className="mb-2"><Link to="/faq">FAQ</Link></li>
              <li className="mb-2"><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>

          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h5>Legal</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/privacy">Privacy Policy</Link></li>
              <li className="mb-2"><Link to="/terms">Terms of Service</Link></li>
              <li className="mb-2"><Link to="/disclaimer">Disclaimer</Link></li>
              <li className="mb-2"><Link to="/cookies">Cookie Policy</Link></li>
            </ul>
          </Col>

          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <h5>Stay Connected</h5>
            <p>Subscribe to our newsletter for the latest deals and updates.</p>
            <Form className="newsletter-form">
              <InputGroup>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  aria-label="Email for newsletter"
                />
                <Button variant="primary" type="submit">
                  <FaPaperPlane />
                </Button>
              </InputGroup>
            </Form>
          </Col>
        </Row>

        <div className="footer-bottom">
          <p>&copy; {currentYear} UniTrade. All Rights Reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
